<template>
	<div>
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane label="部门管理" name="DepMana">
				<DepMana></DepMana>
			</el-tab-pane>
			<el-tab-pane label="职位管理" name="PosMana">
				<PosMana></PosMana>
			</el-tab-pane>
			<el-tab-pane label="权限管理" name="PermissMana">
				<PermissMana></PermissMana>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	// import DepMana from '../../components/plat/basic/DepMana'
	// import PermissMana from '../../components/plat/basic/PermissMana'
	// import PosMana from '../../components/plat/basic/PosMana'
	import DepMana from './components/DepMana'
	import PermissMana from './components/PermissMana'
	import PosMana from './components/PosMana'
	export default {
		name: "PlatInfo",
		data() {
			return {
				activeName: 'DepMana'
			}
		},
		components: {
			'DepMana': DepMana,  // 正常写
			PermissMana,  // 省略写
			PosMana
		}
	}
</script>

<style>
</style>
